module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mui-input-group add-form"
  }, [_c('div', {
    staticClass: "mui-input-row"
  }, [_c('label', [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCard.name),
      expression: "postCard.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.postCard.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCard.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mui-input-row"
  }, [_c('label', [_vm._v("手机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCard.phone),
      expression: "postCard.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机"
    },
    domProps: {
      "value": (_vm.postCard.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCard.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mui-input-row"
  }, [_c('label', [_vm._v("QQ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCard.qq),
      expression: "postCard.qq"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入QQ"
    },
    domProps: {
      "value": (_vm.postCard.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCard.qq = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mui-input-row"
  }, [_c('label', [_vm._v("标签")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCard.tag),
      expression: "postCard.tag"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入标签"
    },
    domProps: {
      "value": (_vm.postCard.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCard.tag = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mui-button-row",
    attrs: {
      "id": "row-first"
    }
  }, [_c('button', {
    staticClass: "mui-btn mui-btn-primary mui-btn-block ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    staticClass: "mui-button-row"
  }, [_c('button', {
    staticClass: "mui-btn mui-btn-danger mui-btn-block ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delPostCard
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "mui-button-row"
  }, [_c('router-link', {
    staticClass: "mui-btn mui-btn-block mui-btn-outlined ",
    attrs: {
      "to": "/list"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-d923c462!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail.vue
// module id = 32
// module chunks = 0